/**
 * Tooltip template for map pins
 *
 * @param {Object} data
 * @returns {string}
 */
export function infoWindowTemplate(data) {
  return `<div class="info-box results-item results-item-v2">
      ${data.html}
  </div>`;
}

export function infoWindowSpinner() {
  return `<div class="info-box results-item info-box-loading">
    <div class="loading-overlay-infowindow">
       <div class="spinner"></div>
    </div>
  </div>`;
}

export function InfoWindow(containerElement, contentElement) {
  this.containerElement = containerElement;
  this.contentElement = contentElement;

  InfoWindow.prototype.setContent = function (content) {
    this.contentElement.innerHTML = content;
  };
  InfoWindow.prototype.open = () => {
    this.containerElement.classList.remove('none');
  };
  InfoWindow.prototype.close = () => {
    this.containerElement.classList.add('none');
  };

  return this;
}

export function getBoundsZoomLevel(minX, maxX, minY, maxY, mapDim) {
  const WORLD_DIM = { height: 256, width: 256 };
  const ZOOM_MAX = 15;

  function latRad(lat) {
    const sin = Math.sin((lat * Math.PI) / 180);
    const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
  }

  function zoom(mapPx, worldPx, fraction) {
    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
  }

  const latFraction = (latRad(maxX) - latRad(minX)) / Math.PI;

  const lngDiff = maxY - minY;
  const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

  const latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
  const lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

  return Math.min(latZoom, lngZoom, ZOOM_MAX);
}
